import { render } from 'preact';
import { App } from './app/App.jsx';
import './styles/layers/00-foundation.css';
import './styles/layers/10-search-courses.css';
import './styles/layers/20-admin-system.css';
import './styles/autopilot.css';
import './styles/layers/40-teachers-auth.css';
import './styles/layers/50-supergrok-shell.css';
import './styles/layers/51-supergrok-orb.css';
import './styles/layers/60-offline-coach.css';
import './styles/layers/70-community-reader.css';
import './styles/theme-previews.css';

render(<App />, document.getElementById('root'));
